import cx from 'classnames';
import { forwardRef } from 'react';
import { NavLink } from 'react-router-dom';
import { ReactComponent as BuyNow } from '../assets/icons/buy-now.svg';
import { ReactComponent as Dashboard } from '../assets/icons/dashboard.svg';
import { ReactComponent as MarketHome } from '../assets/icons/market-home.svg';
import { ReactComponent as Stopwatch } from '../assets/icons/stopwatch.svg';

export default function Nav() {
  const linkClassName =
    'tw-inline-flex tw-flex-col sm:tw-flex-row tw-items-center tw-justify-center md:tw-px-4 tw-text-gray-600 hover:tw-text-secondary active:tw-text-secondary-dark tw-no-underline';
  const activeClassName = 'tw-text-secondary hover:tw-text-secondary';
  return (
    <div className="tw-bg-white tw-border-b tw-border-gray-100">
      <nav className="tw-mx-auto tw-max-w-screen-2xl tw-flex tw-items-center sm:tw-items-stretch tw-h-16 tw-font-bold tw-whitespace-nowrap tw-text-xs sm:tw-text-base">
        <div className="tw-flex tw-justify-center md:tw-justify-start tw-w-1/4">
          <NavLink
            activeClassName={activeClassName}
            className={linkClassName}
            exact
            to="/">
            <MarketHome className="sm:tw-mr-2" />
            Market
          </NavLink>
        </div>
        <div className="tw-flex-auto tw-justify-around md:tw-justify-center tw-flex md:tw-text-lg">
          <NavLink
            activeClassName={cx(activeClassName, 'tw-nav-tab--active')}
            className={cx(linkClassName, 'tw-nav-tab md:tw-mr-6')}
            to="/auctions/">
            <Stopwatch className="sm:tw-mr-2" />
            Auctions
          </NavLink>
          <NavLink
            activeClassName={cx(activeClassName, 'tw-nav-tab--active')}
            className={cx(linkClassName, 'tw-nav-tab ')}
            to="/buynow/">
            <BuyNow className="tw-h-6 sm:tw-mr-2" />
            Buy Now
          </NavLink>
        </div>
        <div className="tw-flex tw-justify-center md:tw-justify-end tw-w-1/4">
          <NavLink
            activeClassName={activeClassName}
            className={linkClassName}
            component={HiddenLink}
            to="/dashboard/">
            <Dashboard className="sm:tw-mr-1" />
            <span className="tw-sr-only lg:tw-not-sr-only">Market</span>
            &nbsp;Dashboard
          </NavLink>
        </div>
      </nav>
    </div>
  );
}

const HiddenLink = forwardRef((props, ref) => (
  <a
    className={props.className}
    href="/market/"
    onClick={event => {
      event.preventDefault();
      props.navigate();
    }}
    ref={ref}>
    {props.children}
  </a>
));
